export const REQUIRED_FIELD_MESSAGE = (fieldName: string = "Field") =>
  `${fieldName} is required`;

export const NOT_VALID_FIELD_MESSAGE = (fieldName: string = "field") =>
  `Invalid ${fieldName} format`;
